import { FormGroup } from '@shared/ui/forms/display';
import { Controller } from 'react-hook-form';
import { InputGroup, SelectPicker } from 'rsuite';
import Note from '@shared/ui/messages/Note';
import { useTranslation } from 'react-i18next';
import { currencySymbols } from '@utils/static';
import { Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ThemeButton } from '@shared/ui/buttons';
import { useSelector, useWatch, useDispatch } from 'react-redux';
import { fetchWithdrawChannels } from '@app/store/slices/withdrawChannelsSlice';
import { RenderItemChannel } from '@shared/ui/forms/select-render';
import { truncateBalance } from '@utils/balance-helpers';
import { useEffect } from 'react';

export default function ChannelsSelect({
  control,
  name,
  label,
  data,
  error,
  close,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { withdrawChannels } = useSelector((state) => state.withdrawChannels);

  // 	{
  //     "id": 10,
  //     "team_id": 2,
  //     "label": "Test",
  //     "currency": "USDT (TRC20)",
  //     "network": "TRC20",
  //     "address": "12389",
  //     "is_active": true,
  //     "created_at": "2025-12-02T12:56:56.000000Z",
  //     "updated_at": "2025-12-02T12:56:56.000000Z"
  // }

  return (
    <FormGroup label={label} error={error}>
      {!withdrawChannels?.length ? (
        <ThemeButton
          icon="add"
          block
          onClick={() => {
            close();
            navigate('/profile');
          }}
        >
          Create withdrawal channel
        </ThemeButton>
      ) : (
        <Controller
          control={control}
          name={name}
          rules={{ required: true }}
          render={({ field }) => (
            <InputGroup inside className={`${field.value ? 'has-value' : ''}`}>
              <SelectPicker
                className="select-bank"
                data={withdrawChannels}
                block
                value={field.value}
                onChange={(value) => field.onChange(value)}
                valueKey="id"
                labelKey="label"
                searchable={false}
                // placeholder={t('select_bank_placeholder')}
                renderMenuItem={(label, item) => (
                  <RenderItemChannel item={item} />
                )}
                renderValue={(label, item) => {
                  return <RenderItemChannel item={item} />;
                }}
              />
            </InputGroup>
          )}
        />
      )}
    </FormGroup>
  );
}
